"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppointmentModalHeader = void 0;

require("antd/es/button/style/css");

var _button = _interopRequireDefault(require("antd/es/button"));

var _react = _interopRequireDefault(require("react"));

var _proRegularSvgIcons = require("@fortawesome/pro-regular-svg-icons");

var _AntdIcon = _interopRequireDefault(require("../antdIcon/AntdIcon"));

require("./appointmentModalHeader.scss");

const AppointmentModalHeader = props => {
  const showRemove = props.showRemove !== undefined ? props.showRemove : true;
  const showSave = props.showSave !== undefined ? props.showSave : true;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "header-action-container",
    onMouseOver: props.onMouseOver,
    onMouseOut: props.onMouseOut
  }, /*#__PURE__*/_react.default.createElement(_button.default, {
    shape: "circle",
    type: "link",
    className: "header-action close",
    icon: /*#__PURE__*/_react.default.createElement("div", {
      title: "Close"
    }, /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
      fontAwesomeIcon: _proRegularSvgIcons.faTimes,
      classes: "header-action-icon"
    })),
    onClick: props.closeClick
  }), showRemove && /*#__PURE__*/_react.default.createElement(_button.default, {
    shape: "circle",
    type: "link",
    className: "header-action",
    icon: /*#__PURE__*/_react.default.createElement("div", {
      title: "Delete"
    }, /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
      fontAwesomeIcon: _proRegularSvgIcons.faTrashAlt,
      classes: "header-action-icon"
    })),
    onClick: props.removeClick
  }), !props.editing ? /*#__PURE__*/_react.default.createElement(_button.default, {
    shape: "circle",
    type: "link",
    className: "header-action",
    icon: /*#__PURE__*/_react.default.createElement("div", {
      title: "Edit"
    }, /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
      fontAwesomeIcon: _proRegularSvgIcons.faPen,
      classes: "header-action-icon"
    })),
    onClick: props.editClick
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, showSave && /*#__PURE__*/_react.default.createElement(_button.default, {
    shape: "circle",
    type: "link",
    className: "header-action",
    icon: /*#__PURE__*/_react.default.createElement("div", {
      title: "Save"
    }, /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
      fontAwesomeIcon: _proRegularSvgIcons.faSave,
      classes: "header-action-icon"
    })),
    onClick: props.saveClick
  })));
};

exports.AppointmentModalHeader = AppointmentModalHeader;